import React from 'react';
import { useSelector } from 'react-redux';

// Helpers
import WorkspaceRecentUpdatesHelper from 'Shared/model_helpers/WorkspaceRecentUpdates.helper';
import MeetingItemHelpers from 'Shared/model_helpers/MeetingItem.helper';

// Selectors
import * as meetingItemSelectors from 'Shared/selectors/MeetingItems.selectors';

// Components
import NotificationHeader from './partials/NotificationHeader';
import NotificationComment from './partials/NotificationComment';

// Styles
import './NewCommentNotification.scss';

type Props = {
  notification;
};

const NewCommentNotification = ({ notification }: Props) => {
  const meetingItemUuid = WorkspaceRecentUpdatesHelper.getMeetingItemUuid(notification);

  const meetingItem = useSelector(state => meetingItemSelectors.getMeetingItemByUuid(state, { meetingItemUuid })).get(
    meetingItemUuid
  );

  if (!meetingItem) return null;

  let bodyRawText = MeetingItemHelpers.getBodyRawText(meetingItem);

  // TODO: (josh) - this stinks - need to find a truncate method that
  // allows truncating with spans and dom elements
  bodyRawText = bodyRawText.length > 40 ? `${bodyRawText.substring(0, 40)}...` : bodyRawText;

  const baseClassName = 'NewCommentNotification';

  const label = (
    <>
      {bodyRawText ? (
        <>
          added a new comment to <span className={`${baseClassName}__body-text`}>{bodyRawText}</span>
        </>
      ) : (
        <>added a new comment</>
      )}
    </>
  );

  return (
    <div className={baseClassName}>
      <NotificationHeader notification={notification} label={label} />
      <NotificationComment notification={notification} />
    </div>
  );
};

export default NewCommentNotification;
